import { MRT_ColumnDef } from "material-react-table";
import React, { useMemo } from "react";
import { ConfiguracionTransitoInterface } from "../types/configuracion-transito.interface";
import { format } from "date-fns"
import DeleteIcon from '@mui/icons-material/Delete';
import IconButton from '@mui/material/IconButton';

export const useTablaColumnsConfiguracionTransito = (
  handleDelete: (item: ConfiguracionTransitoInterface) => void
) => {

  const columnsConfiguracionTransito = useMemo<MRT_ColumnDef<ConfiguracionTransitoInterface>[]>(
    () => [
      {
        id: 'acciones',
        header: 'ACCIONES',
        Cell: ({ row }) =>
          React.createElement(
            IconButton,
            {
              onClick: () => handleDelete(row.original),
              size: 'small',
            },
            React.createElement(DeleteIcon)
          ),
      },
      {
        accessorKey: 'tiempo_ejecucion',
        header: 'EJECUCIÓN CADA (HORAS)',
      },
      {
        accessorKey: 'fecha_creacion',
        header: 'FECHA DE CREACIÓN',
        Cell: ({ cell }) => {
          const fecha = cell.getValue() as string;
          if (!fecha) return '-';
          try {
            return format(
              new Date(fecha),
              'yyyy-MM-dd HH:mm:ss'
            );
          } catch {
            return fecha;
          }
        },
      },
      {
        accessorKey: 'user_create',
        header: 'USUARIO CREA',
      },
      {
        accessorKey: 'estado',
        header: 'ESTADO',
        Cell: ({ cell }) => {
          const value = cell.getValue<boolean>();
          return value === true ? 'ACTIVO' : value === false ? 'BLOQUEADO' : '-';
        },
      },
      {
        accessorKey: 'bodega_custodia_data.nombre',
        header: 'BODEGA CUSTODIA',
      },
      {
        accessorKey: 'ubicacion_custodia_data.nombre',
        header: 'UBICACION CUSTODIA',
      },
    ],
    [],
  );

  return {
    columnsConfiguracionTransito,
  }
}